import styled from "styled-components";

const Text = styled.span`
  margin: 0px;
  bottom: 0;
  font-weight: 400;
  line-height: 145%;
  font-family: ${(p) => p.theme.fontFamily};
  display: ${(p) => (p?.style?.display ? p?.style?.display : "block")};
  color: ${(p) => (p.color ? p.color : p.theme.colors.neutral3)};
  font-size: ${(p) => (p?.style?.fontSize ? p.style.fontSize : "14px")};
`;

export default Text;
